<template>
<div class="simple-scroll" id="scroller" v-dragscroll.x="true" v-dragscroll.noleft="true">
    <div v-for="(value) in tickers" :key="value" :value="value" class="scroll-card" @click="clicked(value)" v-bind:id="value">
        <PriceChartMini  v-bind:ticker="value" height="cellsize" width="cellsize" class="card"></PriceChartMini>
    </div>
</div>
</template>

<script>
import PriceChartMini from "./PriceChartMini.vue";
import { dragscroll } from 'vue-dragscroll';

export default {
  name: "ScrollingMiniCharts",
  components: {
    PriceChartMini
  },
  directives: {
    dragscroll,
  },
  data() {
    return {
      tickerInput: null,
      tickers: ["AMZN","AAPL","GOOG","BTC-USD","ETH-USD","META","MSFT","NFLX","NVDA","TSLA","AMD","IBM","JPM","DIS"],
      // tickers: ["AMZN","AAPL","GOOG","BTC-USD","ETH-USD","META","MSFT"],
      otherTickers:["QCOM","INTC","CSCO","ADBE","VSAT","BB","INTU"],
      cellsize: "100px",
      tickersHidden: [],
    };
  },
  mounted() {
    setInterval(this.scrollMiniCharts,45); // scrolls every 45 milliseconds
    // setInterval(this.carousel, 1000); // scrolls every 1 second
  },
  methods: {
    clicked(value) {
      this.$emit('clicked',value)
    },
    scrollMiniCharts() {
      var el = document.getElementById("scroller")
      el.scrollBy(1,0)
    },
  }
};
</script>

<style scoped>

.scroll-card {
  display: inline-block;
  margin-left: 10px;
  margin-right: 10px;
  margin-top: 10px;
  margin-bottom:10px;

}

.simple-scroll {
  overflow-x: hidden;
  overflow-y: hidden;
  white-space: nowrap;
  flex-wrap: wrap;

}


</style>
